<template>
    <div class="nameMgt" v-if="isshow">
        <div class="singInTitle">签到标题：{{nameData.subject}}</div>
        <div class="singNameList_box">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="名单管理" name="first">
                    <div class="nameListTop">
                        <div class="nameList_left">
                            <span class="importList" @click="importName" v-if="nameData.isverifylist==1">导入名单</span>
                            <span @click="exportList">导出名单</span>
                        </div>
                        <div class="nameList_right">
                            <div><el-date-picker v-model="singInTime" type="datetimerange" range-separator="至" start-placeholder="签到开始时间" end-placeholder="签到结束时间" value-format="yyyy-MM-dd HH:mm"></el-date-picker></div>
                            <div>
                                <el-select v-model="params.status" placeholder="全部状态">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                            <div><el-input v-model="params.keyword" placeholder="输入关键字"></el-input></div>
                            <div class="nameList_search" @click="search">搜索</div>
                        </div>
                    </div>
                    <!--下面表格-->
                    <div class="nameListBottom">
                        <!--无数据时-->
                        <div class="nameListTable noDataBox" v-if="!tableData">
                            <img :src="noData" alt="" class="noDataImg">
                            <p>当前暂无数据</p>
                        </div>
                        <div class="nameListTable" v-else>
                            <el-table :data="tableData" border style="width: 100%">
                                <el-table-column type="index" :index="indexMethod" width="55" label="序号"></el-table-column>
                                <el-table-column prop="name" label="姓名"></el-table-column>
                                <template v-if="nameData.isverifylist==1">
                                    <el-table-column prop="mobileno" label="手机"></el-table-column>
                                    <el-table-column prop="eticketno" label="票号"></el-table-column>
                                    <el-table-column prop="ticketname" label="票种"></el-table-column>
                                </template>
                                <el-table-column  v-for="(item,index) in customList" :key="index" :prop=item.colinnerid  :label=item.colname></el-table-column>
                                <el-table-column prop="signtime" label="签到时间"></el-table-column>
                                <el-table-column label="签到人">
                                    <template scope="scope">
                                        <div class="singInPerson">
                                            <img v-if="scope.row.status==1" :src="scope.row.logourl?scope.row.logourl:heade_bg" class="head_pic"/>
                                            <span>{{ scope.row.nickname }}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="state" label="状态">
                                    <template scope="scope">
                                        <span v-if="scope.row.status==1" style="color: #E6A23C">· 已签到</span>
                                        <span v-else style="color: #F56C6C">· 未签到</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <page :total="total" @getList="_getList" ref="page"></page>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="数据分析" name="second">
                    <div class="nameListTop">
                        <div class="nameList_right">
                            <div><el-date-picker v-model="singInTime2" type="datetimerange" range-separator="至" start-placeholder="签到开始时间" end-placeholder="签到结束时间" value-format="yyyy-MM-dd HH:mm"></el-date-picker></div>
                            <div><el-input v-model="paramstwo.betweentime" placeholder="间隔时间"></el-input></div>
                            <div class="nameList_search" @click="findevent">搜索</div>
                        </div>
                    </div>
                    <div class="dataAnalysis">
                        <div class="dataLeft">
                            <p>签到信息</p>
                            <el-table :data="signList" border style="width: 100%" class="normalTable">
                                <el-table-column type="index" width="55" label="序号"></el-table-column>
                                <el-table-column prop="datetime" label="签到时间"></el-table-column>
                                <el-table-column prop="count" label="签到人数"></el-table-column>
                            </el-table>
                        </div>
                        <div class="dataRight">
                            <p>签到情况</p>
                            <div class="echert" v-if="activeName=='second'">
                                <PieReport :data="dataList"></PieReport>
                            </div>
                        </div>
                    </div>
                    <div class="dataAnalysisBottom">
                        <p>签到情况分布</p>
                        <div class="echert" v-if="activeName=='second'">
                            <LineReport :lineDatas="lineDatas" class="lineDatas"></LineReport>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="签到墙" name="three"></el-tab-pane>
            </el-tabs>
        </div>
        <ExportName ref="exportName" @getList="getList"></ExportName>
    </div>
</template>

<script>
    import ExportName from '@/views/signDataAnalysis/components/exportName'
    import LineReport from 'base/echarts/lineReport'
    import PieReport from 'base/echarts/pieReport'
    import {getSignManagementConditions, getSignNameList, exportSignList, getSignData} from 'api/signApi'
    import Page from 'base/page/page'
    import {mapActions, mapGetters} from 'vuex'
    import {dateFormat} from 'common/js/tools'
    export default {
        name: "NameMgt",
        data(){
            return{
                noData:require('@/common/images/singInImg/noData.png'),
                heade_bg:require('@/common/images/singInImg/heade_bg.png'),
                activeName: 'first',
                singInTime: null, //签到时间
                singInTime2: null, //签到时间2
                dialogVisible:'',
                params:{
                    beginSigntime: '', //开始签到时间
                    endSigntime: '', //结束签到时间
                    status: '',  //选择状态
                    keyword: '',   //输入关键字
                    isverifylist: '', //是否名单验证
                },
                paramstwo:{
                    beginSigntime: '', //开始签到时间
                    endSigntime: '', //结束签到时间
                    betweentime:'', //间隔时间
                },
                options: [{
                    value: '',
                    label: '全部'
                },{
                    value: '0',
                    label: '未签到'
                },{
                    value: '1',
                    label: '已签到'
                }],
                //表格部分
                total: 0,
                tableData: [],
                nameData:{},
                customList:[], // 自定义字段list
                isdata:false,
                isshow:false,
                // 数据分析
                signList:[], //签到信息
                dataList: {id: 'sexTotal', color: ['#4A90E2','#F5A623'], list: [], total: 0, subText: ''},
                lineDatas: {
                    id: 'Data',
                    subText: '',
                    xdata: [],
                    data: [],
                    legendAddr: 'left'
                }
            }
        },
        mounted(){
          this._getTableList()
          document.title="签到360-简单方便的签到工具-鲸融网"
        },
        methods:{
            indexMethod (index) {
                let curpage = this.page.page   //单前页码
                let limitpage = this.page.pagesize    //每页条数
                return (index+1) + (curpage-1)*limitpage
            },
            handleClick(){
                if(this.activeName=='three'){
                    this.$router.push({name: 'SignWall'})
                }
            },
            getList(){
                this._getList()
            },
            // 获取动态表格信息
            _getTableList(){
                this.setLoading(true);
                getSignManagementConditions({
                    success: data => {
                        this.setLoading(false);
                        this.nameData=data.data
                        this.customList = data.data.customList
                        this.isshow=true
                        this._getList()
                        this.getSignData()
                        // this.$nextTick(() => {
                        //
                        // })
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    },
                })
            },
            // 获取名单管理
            _getList(){
                this.setLoading(true);
                this.params.isverifylist=this.nameData.isverifylist
                if(this.singInTime){
                    this.params.beginSigntime = this.singInTime[0]
                    this.params.endSigntime = this.singInTime[1]
                }else{
                    this.params.beginSigntime = ''
                    this.params.endSigntime = ''
                }
                getSignNameList({
                    data: Object.assign({}, this.params,this.page),
                    success: data => {
                        this.setLoading(false);
                        this.tableData=data.data.list
                        this.total = data.data.splitPage.rowCount
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    },
                })
            },
            // 名单管理搜索
            search(){
                this.page.page=1
                this._getList()
            },
            // 导出名单
            exportList(){
                this.setLoading(true);
                this.params.isverifylist=this.nameData.isverifylist
                if(this.singInTime){
                    this.params.beginSigntime = this.singInTime[0]
                    this.params.endSigntime = this.singInTime[1]
                }else{
                    this.params.beginSigntime = ''
                    this.params.endSigntime = ''
                }
                exportSignList({
                    data: Object.assign({}, this.params),
                    success: data => {
                        console.log(data)
                        this.setLoading(false)
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '名单管理' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.$message.success('导出成功')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 导入名单
            importName(){
                this.$refs.exportName.open()
            },
            // 获取数据分析
            getSignData(){
                this.setLoading(true);
                console.log('执行了')
                if(this.singInTime2){
                    this.paramstwo.beginSigntime = this.singInTime2[0]
                    this.paramstwo.endSigntime = this.singInTime2[1]
                }else{
                    this.paramstwo.beginSigntime = ''
                    this.paramstwo.endSigntime = ''
                }
                getSignData({
                    data: Object.assign({}, this.paramstwo),
                    success: data => {
                        this.setLoading(false);
                        this.isdata=true
                        this.signList=data.data.list
                        this.dataList.list = data.data.sincountarrayNode
                        this.lineDatas.xdata = data.data.xdate
                        this.lineDatas.data.push(
                            {
                                color: '#1890FF',
                                smooth: true,
                                symbol: 'circle',
                                list: data.data.zhexianlist
                            }
                        )
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    },
                })
            },
            // 数据分析搜索
            findevent(){
                this.getSignData()
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page',
            ])
        },
        components:{
            ExportName, Page, LineReport, PieReport
        }
    }
</script>

<style lang="scss">
    .nameMgt{
        .singInTitle{
            background: rgba(250,250,250,1);
            width: 100%;
            height: 60px;
            line-height: 60px;
            margin-top: 10px;
            text-indent: 30px;
        }
        .singNameList_box{
            padding: 0 30px;
            .nameListTop{
                height: 70px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .nameList_left{
                    min-width: 250px;
                    span{
                        width:96px;
                        height:36px;
                        line-height: 36px;
                        background:rgba(42,126,251,1);
                        border-radius:4px;
                        display: inline-block;
                        color: #fff;
                        font-size: 14px;
                        text-align: center;
                        margin-right: 25px;
                        cursor: pointer;
                    }
                }
                .nameList_right{
                    display: flex;
                    align-items: center;
                    div{
                        margin-right: 20px;
                    }
                    .nameList_search{
                        width:96px;
                        height:36px;
                        line-height: 36px;
                        background:rgba(230,241,252,1);
                        border-radius:4px;
                        border:1px solid rgba(163,208,253,1);
                        font-size: 14px;
                        color: #1989FA;
                        text-align: center;
                        margin-right: 0;
                        cursor: pointer;
                    }
                }
            }
            .nameListBottom{
                padding-bottom: 80px;
                .noDataBox{
                    width: 400px;
                    text-align: center;
                    margin: 160px auto 0;
                    img{
                        width: 80%
                    }
                    p{
                        font-size: 24px;
                        color: #CECECE;
                        padding-top: 60px;
                    }
                }
                .nameListTable{
                    .el-table{
                        th{
                            height: 50px;
                        }
                        td{
                            height: 70px;
                        }
                        .el-table--border{
                            border: none;
                        }
                        .singInPerson{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            span{
                                display: inline-block;
                            }
                            /*表格里头像图片*/
                            .head_pic{
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                vertical-align: middle;
                                margin-right: 10px;
                            }
                        }
                    }
                    .el-table--border, .el-table--group{
                        border: none;
                    }
                    .el-table--border::after, .el-table--group::after{
                        width: 0;
                    }
                    .el-table--border th{
                        background:rgba(250,250,250,1);
                        color: #303133;
                    }
                    .el-table--border td,.el-table .cell{
                        text-align: center;
                    }
                    .el-table--border td,.el-table--border th{
                        border-right: none;
                    }
                }
            }
            .dataAnalysis{
                display: flex;
                justify-content: space-between;
                .dataLeft{
                    width: 50%;
                    .normalTable  td,.normalTable  th{
                        height: 40px;
                        border-right: 1px solid #e5e5e5;
                    }
                    .normalTable td,.normalTable .cell{
                        text-align: left;
                    }
                    .normalTable  td:last-child{
                        border-right: none;
                    }
                    .normalTable{
                        height: 360px;
                        overflow: hidden;
                        border: 1px solid #e5e5e5;
                        border-bottom: none;
                        .el-table__body-wrapper{
                            max-height: 360px;
                            overflow-y: scroll;
                        }
                    }
                }
                .dataRight{
                    width: 850px;
                }
                p{
                    font-size: 16px;
                    color: #000;
                    padding-bottom: 15px;
                }
            }
            .dataAnalysisBottom{
                p{
                    font-size: 0.21333rem;
                    color: #000;
                    padding: 10px;
                    margin-top: 10px;
                }
            }
        }
        /*---表格样式更改--*/
        .el-tabs__header{
            margin: 0 0 0 0;
        }
        /*layer样式更改*/
        .layui-layer-title{
            background-color: #fff!important;
        }
        /*分页*/
        .paginationBox{
            width: 100%;
            height: 80px;
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translate(-50%,0);
            background: #fff;
            z-index: 9;
        }
        .el-pagination{
            margin-top: 25px;
            text-align: center;
        }
    }
</style>